import { render, staticRenderFns } from "./CountryRevenueCard.vue?vue&type=template&id=13716a7c&scoped=true"
import script from "./CountryRevenueCard.vue?vue&type=script&lang=js"
export * from "./CountryRevenueCard.vue?vue&type=script&lang=js"
import style0 from "./CountryRevenueCard.vue?vue&type=style&index=0&id=13716a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13716a7c",
  null
  
)

export default component.exports